import { washStationService } from '../../services'

// initial state
const state = () => ({
  washStations: []
})

// actions
const actions = {
  getWashStations({ commit }) {
    washStationService.getWashStations()
      .then(
        washStations => {
          commit('washStationsSuccess', washStations);
        },
        error => {
          commit('washStationsFailure', error);
        }
      );
  },
}

// mutations
const mutations = {
  washStationsSuccess(state, washStations) {
      state.washStations = washStations
  },
  washStationsFailure(state, error) {
      console.log(state, error);
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
